define('MHI.Shopping', [
  'Home.Extension',
  'Facets.ItemCell.View.Extension',
  'Header.Menu.View.Extension',
  'Header.View.Extension',
  'ProductDetails.Full.View.Extension',
  'ItemsearcherExtension',
  'Cart.Lines.View.Extension'
], function () {
  'use strict';

  return {
    mountToApp: function mountToApp(container) {}
  };
});
